var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState, useEffect, cloneElement, } from "react";
import Overlay from "react-bootstrap/Overlay";
import "./Tooltip.scss";
import { styledTooltipText } from "@frameworks/NCD/Utils/styledTooltipText";
var TooltipWrapper = function (_a) {
    var content = _a.content, children = _a.children, containerId = _a.containerId, _b = _a.placement, placement = _b === void 0 ? "top" : _b, _c = _a.textTruncate, textTruncate = _c === void 0 ? false : _c, parentClassName = _a.parentClassName;
    var ref = useRef(null);
    var _d = __read(useState(false), 2), show = _d[0], setShow = _d[1];
    var _e = __read(useState(false), 2), isOverflowing = _e[0], setIsOverflowing = _e[1];
    useEffect(function () {
        if (!textTruncate && ref.current) {
            var overflowCheck = ref.current.scrollWidth > ref.current.clientWidth;
            setIsOverflowing(overflowCheck);
        }
    }, [content, textTruncate]);
    var handleMouseEnter = function () {
        if (textTruncate || isOverflowing) {
            setShow(true);
        }
    };
    var handleMouseLeave = function () { return setShow(false); };
    var child = cloneElement(children, {
        ref: function (node) {
            ref.current = node;
            var originalRef = children.ref;
            if (typeof originalRef === "function")
                originalRef(node);
            else if (originalRef && typeof originalRef === "object") {
                originalRef.current = node;
            }
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });
    return (React.createElement(React.Fragment, null,
        child,
        React.createElement(Overlay, { target: ref.current, show: show, placement: placement, container: containerId && document.getElementById(containerId)
                ? document.getElementById(containerId)
                : document.body }, function (_a) {
            var placement = _a.placement, overlayProps = __rest(_a, ["placement"]);
            var hasDoneInitialMeasure = overlayProps.hasDoneInitialMeasure, popper = overlayProps.popper, arrowProps = overlayProps.arrowProps, safeProps = __rest(overlayProps, ["hasDoneInitialMeasure", "popper", "arrowProps"]);
            return (React.createElement("div", __assign({ className: "tooltip bs-tooltip-".concat(placement, " show custom-tooltip-overlay ").concat(parentClassName), role: "tooltip" }, safeProps),
                React.createElement("div", { className: "custom-tooltip-overlay ".concat(parentClassName) },
                    React.createElement("div", { className: "tooltip-inner" }, styledTooltipText(content)))));
        })));
};
export default TooltipWrapper;
